"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseHostname = exports.Environment = void 0;
var environment_1 = require("./environment");
Object.defineProperty(exports, "Environment", { enumerable: true, get: function () { return environment_1.Environment; } });
var parseHostname_1 = require("./parseHostname");
Object.defineProperty(exports, "parseHostname", { enumerable: true, get: function () { return __importDefault(parseHostname_1).default; } });
